import {CallbacksAuth0Component} from './components/callbacks-auth0/callbacks-auth0.component';

export const authRoutes = [
    {
        path: 'callbacks/auth0',
        component: CallbacksAuth0Component
    }
];
